import axios from 'axios';
import PQueue from 'p-queue/dist';
import router from '../router';

import tokenExpirePromise from '../components/core/dialogs/tokenExpireDialog';
import permissionCheckService from './permissionCheckService';
import vueAppSubfolder from '../utils/appSubfolderUtils';
const defaultAxiosOptions = {
	baseURL: vueAppSubfolder.get(),
};

class HttpClientService {
	axiosInstance;

	constructor() {
		global.queue = new PQueue({ concurrency: 1, autoStart: true });
		this.beforeRequest = this.beforeRequest.bind(this);
		this.onRequestFailure = this.onRequestFailure.bind(this);
		this.axiosInstance = axios.create(defaultAxiosOptions);
		this.axiosInstance.interceptors.request.use(this.beforeRequest);
		this.axiosInstance.interceptors.response.use(
			this.onRequestSuccess,
			this.onRequestFailure
		);
	}

	beforeRequest(request) {
		if (request.url.includes('/IdentityWindowsModule/api')) return request;
		const token = localStorage.bearer;
		if (token) {
			request.headers.Authorization = `Bearer ${token}`;
		}
		return request;
	}

	onRequestSuccess(response) {
		return response;
	}

	onRequestFailure(err) {
		const { response } = err;
		if (response.status == 401 && localStorage.bearer) {
			// if login request throw err -> we don't need retry in this case;
			if (
				response.config.url.toLowerCase() === '/identitymodule/api/auth'
			) {
				return Promise.reject(err);
			}

			if (
				response.config.url.toLowerCase() ===
				'/identitymodule/api/auth/refreshtoken'
			) {
				return Promise.reject(err);
			}

			if (!response.config._retry) {
				global.queue.pause();
				response.config._retry = true;
				return this.GetRefreshToken()
					.then((resp) => {
						localStorage.bearer = resp;
					})
					.catch(() => {
						permissionCheckService.selectedClient = null;
						permissionCheckService.selectedProject = null;
						permissionCheckService.currentUserPermissions = null;
						localStorage.removeItem('bearer');
						global.queue.clear();
						router.push('/login');
						err._hiddenModal = true;
						return Promise.reject(err);
					})
					.then(() => {
						return this.axiosInstance(response.config);
					})
					.finally(() => {
						global.queue.start();
					});
			} else {
				return Promise.reject(err);
			}
		} else {
			//other http erros; httpStatus !=401
			return Promise.reject(err);
		}
	}

	GetRefreshToken() {
		return new Promise((resolve, reject) => {
			this.axiosInstance
				.post('/IdentityModule/api/Auth/RefreshToken', {
					AccessToken: localStorage.bearer,
				})
				.then((resp) => {
					resolve(resp.data);
				})
				.catch((error) => {
					tokenExpirePromise(localStorage.bearer).then((resp) => {
						if (resp) {
							resolve(resp);
						} else {
							reject(error);
						}
					});
				});
		});
	}

	GetWindowsUsername() {
		return this.axiosInstance.get(
			'/IdentityWindowsModule/api/Auth/windowsUsername'
		);
	}

	GetLoginMethods() {
		return this.axiosInstance.get('/UserContextModule/api/Login/method');
	}
	Auth(userCredentials) {
		return this.axiosInstance.post(
			'/IdentityModule/api/Auth',
			userCredentials
		);
	}
	AuthWindows() {
		return this.axiosInstance.get('/IdentityWindowsModule/api/Auth');
	}

	Get(url, config) {
		return new Promise((resolve, reject) => {
			global.queue.add(async () => {
				await this.axiosInstance
					.get(url, { ...config })
					.then((response) => {
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			});
		});
	}
	GetForDownload(url, config) {
		return new Promise((resolve, reject) => {
			global.queue.add(async () => {
				await this.axiosInstance
					.get(url, {
						responseType: 'blob',
						...config,
					})
					.then((response) => {
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			});
		});
	}

	PostMultiPart(url, data, config) {
		return new Promise((resolve, reject) => {
			global.queue.add(async () => {
				await this.axiosInstance
					.post(url, data, {
						headers: {
							'Content-Type': 'multipart/form-data',
						},
						...config,
					})
					.then((response) => {
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			});
		});
	}

	Post(url, data, config) {
		return new Promise((resolve, reject) => {
			global.queue.add(async () => {
				await this.axiosInstance
					.post(url, data, { ...config })
					.then((response) => {
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			});
		});
	}
	PostForExport(url, data, config) {
		return new Promise((resolve, reject) => {
			global.queue.add(async () => {
				await this.axiosInstance
					.post(url, data, {
						responseType: 'blob',
						...config,
					})
					.then((response) => {
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			});
		});
	}

	Put(url, data, config) {
		return new Promise((resolve, reject) => {
			global.queue.add(async () => {
				await this.axiosInstance
					.put(url, data, { ...config })
					.then((response) => {
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			});
		});
	}

	PutMultiPart(url, data, config) {
		return new Promise((resolve, reject) => {
			global.queue.add(async () => {
				await this.axiosInstance
					.put(url, data, {
						headers: {
							'Content-Type': 'multipart/form-data',
						},
						...config,
					})
					.then((response) => {
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			});
		});
	}

	Delete(url, data) {
		return new Promise((resolve, reject) => {
			global.queue.add(async () => {
				await this.axiosInstance
					.delete(url, { data })
					.then((response) => {
						resolve(response);
					})
					.catch((error) => {
						reject(error);
					});
			});
		});
	}
}

const httpClientService = new HttpClientService();
export default httpClientService;
export { HttpClientService };
